import React from "react";
import ReactDOM from "react-dom";
import "./common.css";
import {
  Form,
  Select,
  Button,
  Row,
  Col,
  message,
  Menu,
  Dropdown,
  Typography,
} from "antd";
import TableContainer from "./Transpose/TableContainer";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import {
  setComplianceStatusView,
  setComplianceDateView,
} from "../../../../store/actions/complianceTableActions";
import * as actions from "../../../../store/actions/indexes";
import {
  SyncOutlined,
  CaretDownOutlined,
  ShareAltOutlined,
} from "@ant-design/icons";
import { MUICloudDownloadIcon } from "../../../../assets/svgToIconCovert";
import { axiosInstance2 } from "../../../../utils/axiosConfig";
import commonConfig from "../../../commonConfig.json";
import { CustomSlider } from "../SliderComponent";
import ExcelShareModal from "../ExcelShareModal/index";

const { Option } = Select;
const { Item } = Menu;
const { Text } = Typography;

const exportTypes = commonConfig.exportTypes;

class ResultTable extends React.Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.state = {
      winWidth: window.innerWidth,
      winHeight: window.innerHeight,
      excelShareModalOpen: false,
    };
    this.updateDimensions = this.updateDimensions.bind(this);
    this.onDrpDwnOpenClose = this.onDrpDwnOpenClose.bind(this);
    this.closeExcelShareModal = this.closeExcelShareModal.bind(this);
    this.openExcelShareModal = this.openExcelShareModal.bind(this);
  }

  closeExcelShareModal = () => {
    this.setState({ excelShareModalOpen: false });
  };

  openExcelShareModal = () => {
    this.setState({ excelShareModalOpen: true });
  };

  updateSMConfiguration(newData) {
    axiosInstance2
      .post("/api/callExternal/saveUserCompCustomisation", newData)
      .then((response) => {
        console.log("response", response.data);
      })
      .catch((error) => {
        console.error("ERROR :", error);
      });
  }
  handleTransposeChange = (value) => {
    this.props.setComplianceDateView(value);
    let newData = {
      dateView: value,
      statusView: this.props.status,
      userId: this.props.userId,
    };
    this.updateSMConfiguration(newData);
  };
  handleStatusChange = (value) => {
    this.props.setComplianceStatusView(value);
    let newData = {
      dateView: this.props.transpose,
      statusView: value,
      userId: this.props.userId,
    };

    this.updateSMConfiguration(newData);
  };

  handleExcelExport = (exportType, share) => {
    this.props.handleExcelExport(exportType, share);
  };

  refreshTbl = () => {
    this.props.refreshTbl();
  };

  updateDimensions = () => {
    this.setState({
      winWidth: window.innerWidth,
      // winHeight: window.innerHeight
    });
  };

  componentDidMount() {
    window.addEventListener("resize", () => this.updateDimensions());
  }

  componentWillUnmount() {
    window.removeEventListener("resize", () => this.updateDimensions());
  }

  onDrpDwnOpenClose = (e) => {
    if (e) {
      let copyOfFilterStates = JSON.parse(
        JSON.stringify(this.props.isControlledFiltersOpen)
      );
      for (const key in copyOfFilterStates) {
        copyOfFilterStates[key] = false;
      }
      this.props.setControlledFiltersOpen(copyOfFilterStates);
    }
  };
  render() {
    let validOptions = [];
    let options = [];
    if (
      this.props.complianceStatus !== undefined &&
      this.props.complianceStatus.length !== 0
    ) {
      options = this.props.complianceStatus.sort((a, b) => {
        return a.toLowerCase() > b.toLowerCase() ? 1 : -1;
      });
      let temp = [];
      options.forEach((level) => {
        let conv = level.split(" ")[0];
        if (
          this.props.compliance_signature &&
          !this.props.compliance_upload &&
          conv === "Report"
        ) {
        } else if (
          !this.props.compliance_signature &&
          this.props.compliance_upload &&
          conv === "Signature"
        ) {
        } else {
          temp.push(
            <Option key={"statusView_" + conv.toLowerCase()} value={level}>
              {conv}
            </Option>
          );
          validOptions.push(level);
        }
      });

      options = [...temp];
    } else {
      options = (
        <>
          <Option key="statusView_signature" value="Signature Status">
            Signature
          </Option>
          <Option key="statusView_report" value="Report Status">
            Report
          </Option>
        </>
      );
    }

    if (options.length === 0) {
      message.error("Incorrect configuration, please check System Manager");
    } else if (options.length > 1) {
      validOptions.push("All");
      options = [
        <Option key="statusView_all" value="All">
          All
        </Option>,
      ].concat(options);
    }
    if (validOptions.length > 0 && !validOptions.includes(this.props.status)) {
      this.handleStatusChange(validOptions[0]);
    }

    let menu = (
      <Menu>
        <Item
          key="percentage"
          title="Compliance Status (%).xlsx"
          className="padding-6"
        >
          <div
            className="exportHover"
            id={exportTypes.PERCENTAGE}
            onClick={() => {
              this.handleExcelExport(exportTypes.PERCENTAGE, false);
            }}
          >
            {"Compliance Status (%)\t.xlsx"}
          </div>
        </Item>
        <Item key="missing" title="Missing Reports .xlsx" className="padding-6">
          <div
            className="exportHover"
            id={exportTypes.MISSING_REPORTS}
            onClick={() => {
              this.handleExcelExport(exportTypes.MISSING_REPORTS, false);
            }}
          >
            {"Missing Reports\t.xlsx"}
          </div>
        </Item>
        {this.props.status === "Signature Status" ||
        this.props.status === "All" ? (
          <Item
            key="missing"
            title="Signer Details .xlsx"
            className="padding-6"
          >
            <div
              className="exportHover"
              id={exportTypes.SIGNER_DETAILS}
              onClick={() => {
                this.handleExcelExport(exportTypes.SIGNER_DETAILS, false);
              }}
            >
              {"Signer Details\t.xlsx"}
            </div>
          </Item>
        ) : (
          ""
        )}
        {this.props.status === "Report Status" ||
        this.props.status === "All" ? (
          <Item
            key="missing"
            title="Report Status - Timestamp .xlsx"
            className="padding-6"
          >
            <div
              className="exportHover"
              id={exportTypes.REPORT_STATUS_TIMESTAMP}
              onClick={() => {
                this.handleExcelExport(
                  exportTypes.REPORT_STATUS_TIMESTAMP,
                  false
                );
              }}
            >
              {"Report Status - Timestamp\t.xlsx"}
            </div>
          </Item>
        ) : (
          ""
        )}
      </Menu>
    );

    return (
      <div className="innerSection">
        {this.state.winWidth < 992 ? (
          <Row style={{ width: "100%" }}>
            <Col xs={24} sm={24}>
              <Row
                style={{ width: "100%", fontSize: "12px" }}
                gutter={[8, 16]}
                align="bottom"
              >
                <Col xs={9} sm={6}>
                  <Text strong>Date View</Text>
                  <Select
                    id="date_view_drpdwn"
                    key="date_view_drpdwn"
                    value={this.props.transpose}
                    className="statusClz"
                    onChange={(e) => this.handleTransposeChange(e)}
                    onDropdownVisibleChange={(e) => this.onDrpDwnOpenClose(e)}
                    suffixIcon={
                      <CaretDownOutlined className="ant-select-suffix" />
                    }
                  >
                    <Option key="dateView_horizontal" value="horizontal">
                      Horizontal
                    </Option>
                    <Option key="dateView_verticle" value="vertical">
                      Vertical
                    </Option>
                  </Select>
                </Col>
                <Col xs={9} sm={6}>
                  <Text strong>Status View</Text>
                  <Select
                    id="status_view_drpdwn"
                    key="status_view_drpdwn"
                    value={this.props.status}
                    className="statusClz"
                    onChange={(e) => this.handleStatusChange(e)}
                    onDropdownVisibleChange={(e) => this.onDrpDwnOpenClose(e)}
                    disabled={validOptions.length === 1 ? true : false}
                    suffixIcon={
                      <CaretDownOutlined className="ant-select-suffix" />
                    }
                  >
                    {options}
                  </Select>
                </Col>
                <Col xs={3} sm={2} className="refreshBtnDiv">
                  <Button
                    type="primary"
                    onClick={this.refreshTbl}
                    icon={<SyncOutlined style={{ verticalAlign: "0.125em" }} />}
                    className="refreshBtn"
                  ></Button>
                </Col>
                <Col
                  xs={3}
                  sm={4}
                  hidden={
                    !this.props.compExcelReportShare
                  }
                >
                  <Button
                    type="primary"
                    onClick={this.openExcelShareModal}
                    icon={
                      this.state.winWidth < 768 ? (
                        <ShareAltOutlined
                          style={{ verticalAlign: "0.125em" }}
                        />
                      ) : (
                        ""
                      )
                    }
                  >
                    {this.state.winWidth < 768 ? "" : "Share"}
                  </Button>
                  <ExcelShareModal
                    disabled={
                      this.props.qmsApi.complianceTableData.length !== 0
                        ? false
                        : true
                    }
                    isOpen={this.state.excelShareModalOpen}
                    handleClose={this.closeExcelShareModal}
                    status={this.props.status}
                    selectedHotels={null}
                    selectedDates={null}
                    handleExcelExport={this.handleExcelExport}
                    exportDefaultSubject={this.props.exportDefaultSubject}
                  />
                </Col>
                <Col xs={3} sm={4} hidden={!this.props.complianceExportAccess}>
                  <Dropdown overlay={menu} placement="bottomRight">
                    {this.state.winWidth < 768 ? (
                      <Button
                        type="primary"
                        className="excelBtn"
                        icon={<MUICloudDownloadIcon />}
                        disabled={
                          this.props.qmsApi.complianceTableData.length !== 0
                            ? false
                            : true
                        }
                      ></Button>
                    ) : (
                      <Button
                        type="primary"
                        className="excelBtn"
                        disabled={
                          this.props.qmsApi.complianceTableData.length !== 0
                            ? false
                            : true
                        }
                      >
                        Export
                      </Button>
                    )}
                  </Dropdown>
                </Col>
              </Row>
              {this.state.winWidth < 768 ? (
                <Row
                  style={{ width: "100%", fontSize: "12px" }}
                  gutter={[8, 16]}
                  align="middle"
                >
                  <Col xs={24} sm={24}>
                    <Text strong>Compliance Range</Text>
                    <CustomSlider
                      range={true}
                      setCompRange={this.props.setCompRange}
                    />
                  </Col>
                </Row>
              ) : (
                <Row
                  style={{ width: "100%", fontSize: "12px" }}
                  gutter={[8, 16]}
                  align="middle"
                >
                  <Col xs={6} sm={6}>
                    <Text strong>Compliance Range</Text>
                  </Col>
                  <Col xs={18} sm={18}>
                    <CustomSlider
                      range={true}
                      setCompRange={this.props.setCompRange}
                    />
                  </Col>
                </Row>
              )}
            </Col>
          </Row>
        ) : (
          <Row
            style={{ width: "100%", fontSize: "12px" }}
            gutter={[8, 16]}
            align="middle"
          >
            <Col>
              <Text strong>Date View</Text>
            </Col>
            <Col md={2} lg={4} xl={3} xxl={2}>
              <Select
                id="date_view_drpdwn"
                key="date_view_drpdwn"
                value={this.props.transpose}
                className="statusClz"
                onChange={(e) => this.handleTransposeChange(e)}
                onDropdownVisibleChange={(e) => this.onDrpDwnOpenClose(e)}
                suffixIcon={<CaretDownOutlined className="ant-select-suffix" />}
              >
                <Option key="dateView_horizontal" value="horizontal">
                  Horizontal
                </Option>
                <Option key="dateView_verticle" value="vertical">
                  Vertical
                </Option>
              </Select>
            </Col>
            <Col>
              <Text strong>Status View</Text>
            </Col>
            <Col md={2} lg={4} xl={3} xxl={2}>
              <Select
                id="status_view_drpdwn"
                key="status_view_drpdwn"
                value={this.props.status}
                className="statusClz"
                onChange={(e) => this.handleStatusChange(e)}
                onDropdownVisibleChange={(e) => this.onDrpDwnOpenClose(e)}
                disabled={validOptions.length === 1 ? true : false}
                suffixIcon={<CaretDownOutlined className="ant-select-suffix" />}
              >
                {options}
              </Select>
            </Col>
            <Col>
              <Text strong>Compliance Range</Text>
            </Col>
            <Col md={7} lg={7} xl={7} xxl={7}>
              <CustomSlider
                range={true}
                setCompRange={this.props.setCompRange}
              />
            </Col>
            <Col span={1} className="refreshBtnDiv" justify="end">
              <Button
                type="primary"
                onClick={this.refreshTbl}
                icon={<SyncOutlined style={{ verticalAlign: "0.125em" }} />}
                className="refreshBtn"
              ></Button>
            </Col>
            <Col
              hidden={
                !this.props.compExcelReportShare
              }
            >
              <Button type="primary" onClick={this.openExcelShareModal}>
                Share
              </Button>
              <ExcelShareModal
                disabled={
                  this.props.qmsApi.complianceTableData.length !== 0
                    ? false
                    : true
                }
                isOpen={this.state.excelShareModalOpen}
                handleClose={this.closeExcelShareModal}
                status={this.props.status}
                selectedHotels={null}
                selectedDates={null}
                handleExcelExport={this.handleExcelExport}
                exportDefaultSubject={this.props.exportDefaultSubject}
              />
            </Col>
            <Col
              md={2}
              lg={2}
              xl={{ span: 2, offset: 0 }}
              xxl={{ span: 2, offset: 2 }}
              hidden={!this.props.complianceExportAccess}
              justify="end"
            >
              <Dropdown overlay={menu} placement="bottomRight">
                <Button
                  type="primary"
                  className="excelBtn"
                  disabled={
                    this.props.qmsApi.complianceTableData.length !== 0
                      ? false
                      : true
                  }
                >
                  Export
                </Button>
              </Dropdown>
            </Col>
          </Row>
        )}
        <TableContainer
          settings={this.props.settings}
          changeHotelView={this.props.changeHotelView}
          // selectedHotels={this.props.selectedHotels}
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  // console.log("INITING :::", state.appPermissionsReducer.complianceConfig)
  return {
    qmsApi: state.qmsApi,
    status: state.complianceTableReducer.status,
    transpose: state.complianceTableReducer.transpose,
    complianceExportAccess:
      state.appPermissionsReducer.compliancePermissions.complianceExportAccess,
    complianceStatus:
      state.appPermissionsReducer.complianceConfig.complianceStatus,
    userId: state.userDetailReducer.userId,
    isControlledFiltersOpen:
      state.controlledComponentsReducer.isControlledFiltersOpen,
    compExcelReportShare:
      state.appPermissionsReducer.compliancePermissions.compExcelReportShare,
  };
}

function matchDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      setComplianceStatusView: setComplianceStatusView,
      setComplianceDateView: setComplianceDateView,
      setControlledFiltersOpen: actions.setControlledFiltersOpen,
    },
    dispatch
  );
}

export default connect(mapStateToProps, matchDispatchToProps)(ResultTable);
